import * as vp from 'vopay';
import { Box, Select, TextField, DateRangePicker } from 'vopay';
import { FunctionComponent, useState } from 'react';
import styles from './ApprovalInbox.module.scss';
import { useTranslation } from 'react-i18next';
import { Button } from 'UI';

type ApprovalInboxSearchParams = {
  frequency: string;
  currency: string;
  searchTerm: string;
  timeRange: [vp.Timestamp, vp.Timestamp];
};

type SearchFormProps = {
  frequency: string;
  currency: string;
  searchTerm: string;
  initialTimeRange: [vp.Timestamp, vp.Timestamp];
  hasInvalidEndDate?: boolean;
  shouldShowEndDateError?: boolean;
  setShouldShowEndDateError?: (event: boolean) => void;
  search: (searchParams: ApprovalInboxSearchParams) => void;
};

type FC = FunctionComponent<SearchFormProps>;

const ApprovalInboxSearchForm: FC = ({
  frequency,
  currency,
  searchTerm,
  hasInvalidEndDate,
  shouldShowEndDateError,
  setShouldShowEndDateError,
  initialTimeRange,
  search,
}: SearchFormProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'TransactionApproval.Inbox.SearchForm' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const [currentFrequency, setCurrentFrequency] = useState<string>(frequency);
  const [currentCurrency, setCurrentCurrency] = useState<string>(currency);
  const [currentSearchTerm, setCurrentSearchTerm] = useState<string>(searchTerm);
  const [timeRange, setTimeRange] = useState<[vp.Timestamp, vp.Timestamp]>(initialTimeRange);

  const frequencyOptions = [
    { value: 'all', label: t('Frequency.Options.all') },
    { value: 'single', label: t('Frequency.Options.single') },
    { value: 'recurring', label: t('Frequency.Options.recurring') },
  ];

  const currencyOptions = [
    { value: 'CAD', label: 'CAD' },
    { value: 'USD', label: 'USD' },
  ];

  return (
    <Box flx="row" gap="sm" wrap="wrap">
      <div className={styles.datePickerContainer}>
        <DateRangePicker
          onChange={(range) => {
            setTimeRange(range);
          }}
          initialTime={initialTimeRange}
          hasInvalidEndDate={hasInvalidEndDate}
          shouldShowEndDateError={shouldShowEndDateError}
          setShouldShowEndDateError={setShouldShowEndDateError}
          triggerVariant="outlineShadow"
        />
      </div>
      <Box width="200px">
        <Select
          version="2"
          placeholder={t('currencyPlaceholder')}
          options={currencyOptions}
          name="currency"
          value={currentCurrency}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentCurrency(e.target.value);
          }}
        />
      </Box>
      <Box width="200px">
        <Select
          version="2"
          placeholder={t('Frequency.placeholder')}
          options={frequencyOptions}
          name="frequency"
          value={currentFrequency}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentFrequency(e.target.value);
          }}
        />
      </Box>

      <Box maxwidth="180px">
        <TextField
          key="AccountSearchKeyword"
          name="AccountSearchKeyword"
          placeholder={t('keywordPlaceholder')}
          value={currentSearchTerm}
          onBlur={() => {}}
          onChange={(e) => {
            setCurrentSearchTerm(e.target.value);
          }}
          variant="outlineShadow"
        />
      </Box>

      <Button
        id="search-schedule-transactions"
        size="large"
        colorScheme="primary"
        onClick={() => {
          search({
            frequency: currentFrequency,
            currency: currentCurrency,
            searchTerm: currentSearchTerm,
            timeRange,
          });
        }}
      >
        {tGlobal('Buttons.search')}
      </Button>
    </Box>
  );
};

export default ApprovalInboxSearchForm;
